const colors = {
  //TODO: add more colors as needed
  primary: "#1B244E",
  secondary: "#FFFFFF",
  disabled: "#1B244E45",
  success: "#249689",
  error: "#AA0000",
  borders: {
    light: "#FFFFFF",
    gray: "#888888",
    dark: "#000000",
    input: "#EBEAEA",
  },
  shadows: {
    light: "#FFFFFF",
    dark: "#000000",
    brown: "#e6e1db",
  },

  "success-light": "#D4F7E6",

  fromGradient: "#F1FCFF",
  toGradient: "#EEFCFF",
  stopGradient: "#EBF8FE",

  "light-gray": "#F0F2F3",
  "neutral-gray": "#E4E4E4",
  "dark-gray": "#9A9CAA",
  gray: "#D9DADB",

  "light-blue": "#F3F7FB",
  "neutral-blue": "#D4DAF4",
  blue: "#2435A1",
  "dark-blue": "#1B2128",

  "primary-text": "#272343",

  "light-green": "#92ff8dff",
  green: "#2B9825",
  "dark-green": "#055a00ff",

  "light-pink": "#ff9afcff",
  pink: "#E01DDA",
  "dark-pink": "#990094ff",

  "light-orange": "#ffcb9bff",
  orange: "#DA6F0A",
  "dark-orange": "#813e00ff",
};

module.exports = colors;
